export enum ColumnType {
  DATE = 'DATE',
  DATE_TIME = 'DATE_TIME',
  BOOLEAN = 'BOOLEAN',
  ACTIONS = 'ACTIONS',
  TEXT = 'TEXT',
}

export interface ColumnModel {
  field: string;
  header: string;
  type?: ColumnType;
  filter?: boolean;
  style: { width: string };
}
